module.exports = __webpack_public_path__ + "img/reset.53794a73.jpg";